import './styles/app.css';
import './shims/shopifyGlobal'; // installs window.shopify (toast, etc.) for universal mode
import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import App from './App.jsx';
import currencyData from './CurrencyData.json';
import { identifyCrisp } from './crisp';

// Initialize global app configuration
window.appGlobals = {
  appName: import.meta.env.VITE_APP_NAME || 'Zon Staff Management',
  appVersion: import.meta.env.VITE_APP_VERSION || '1.0.0',
  apiBaseUrl: import.meta.env.VITE_API_BASE_URL || 'https://api.zonstaff.com/api',
  isUniversalMode: import.meta.env.VITE_ENABLE_UNIVERSAL_MODE === 'true',
  currencyData: currencyData
};

// Identify the merchant to support before React mounts. Module scope on
// purpose: on a Wix merchant's first open the bearer token exists only in the
// query string, and WixEmbedded strips it inside an effect that has not run
// yet. No-ops when nobody is signed in.
identifyCrisp();

// The boot screen in index.html is torn down by App itself, not here. Mounting
// is not the same as having something to show: at that moment the auth check
// and the onboarding-status call are both still in flight, so hiding the
// branded screen here handed the merchant a second, unbranded spinner for the
// length of both - two loading states back to back.
ReactDOM.createRoot(document.getElementById('root')).render(
  <React.StrictMode>
    <BrowserRouter
      future={{
        v7_startTransition: true,
        v7_relativeSplatPath: true
      }}
    >
      <App />
    </BrowserRouter>
  </React.StrictMode>
);

